import { API_HOST } from './constants';

export interface AuthConfig {
    clientId: string;
    tenantId: string;
    redirectUrl: string;
}

export interface AppConfig {
    api_base_url: string;
    auth: AuthConfig;
}

const DEFAULT_TENANT_ID = '53784c42-4e11-474b-bede-1666acb2666b';
const DEFAULT_CLIENT_ID_DEV = 'e4b26355-e2ed-4cb1-b7de-10708104ce61';
const DEFAULT_CLIENT_ID_PROD = 'bbb19706-a1ed-49a3-9575-525a2a18df17';

function detectRuntimeEnv(): 'local' | 'dev' | 'prod' {
    const env = (process.env.REACT_APP_ENV || '').toLowerCase();
    if (env === 'local' || env === 'dev' || env === 'prod') return env;

    if (typeof window !== 'undefined') {
        const host = window.location.hostname.toLowerCase();
        if (host.includes('localhost') || host === '127.0.0.1') return 'local';
        if (host.includes('.dev.')) return 'dev';
    }

    return 'prod';
}

export function getApiBaseUrl(): string {
    return API_HOST;
}

export function getAuthConfig(): AuthConfig {
    const runtimeEnv = detectRuntimeEnv();
    const origin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000';

    const tenantId = process.env.REACT_APP_AUTH_TENANT_ID || DEFAULT_TENANT_ID;
    const clientId =
        runtimeEnv === 'prod'
            ? process.env.REACT_APP_AUTH_CLIENT_ID_PROD || DEFAULT_CLIENT_ID_PROD
            : process.env.REACT_APP_AUTH_CLIENT_ID_DEV || DEFAULT_CLIENT_ID_DEV;

    return {
        clientId,
        tenantId,
        redirectUrl: origin,
    };
}
